import { Component, ViewChild, ViewContainerRef, ComponentRef, OnDestroy, Type, signal } from '@angular/core';

@Component({
  selector: 'app-widget-modal',
  templateUrl: './modal.component.html',
  imports: []
})
export class WidgetModalComponent implements OnDestroy {
  /**
   * Contents template
   */
  @ViewChild('contents', { read: ViewContainerRef, static: true }) contents!: ViewContainerRef;

  /**
   * Modal heading
   */
  heading = signal('');

  /**
   * When modal is closed
   */
  closed?: () => void;

  /**
   * Modal reference
   */
  private reference?: ComponentRef<any>;

  /**
   * When component is destroyed
   */
  ngOnDestroy() {
    this.reference?.destroy();
  }

  /**
   * Init modal
   * 
   * @param component 
   * @param heading 
   * @param inputs 
   */
  init<T>(component: Type<T>, heading: string, inputs: Partial<T> = {}) {
    this.contents.clear();
    this.reference = this.contents.createComponent(component);
    this.heading.set(heading);
    Object.assign(this.reference.instance, inputs);
  }

  /**
   * Close modal
   */
  close() {
    this.reference?.destroy();
    this.closed?.();
  }
}